import { IReklamacja } from "./IReklamacja";

export class reklamacja_api {
    
    public static get_historia_zlecenia:string ="/api/reklamacja/get_historia_zlecenia"
    public static get_zlecenia:string ="/api/reklamacja/get_zlecenia"
    public static get_reklamacje_short:string = "/api/reklamacja/get_reklamacje_short"
    public static find_by_id:string = "/api/reklamacja/find_by_id"
    public static create:string = "/api/reklamacja/create"
    public static update:string = "/api/reklamacja/update"
    public static delete:string = "/api/reklamacja/delete"
    
}

export interface IReklamacjaSvc {
    
    get_historia_zlecenia(zlecprod_id: number): Promise<any[]>
    get_zlecenia(filter:string): Promise<any[]>
    get_reklamacje_short(limit:number): Promise<IReklamacja[] | undefined> 
    find_by_id(_id: any): Promise<IReklamacja | undefined> 
    create(reklamacja:IReklamacja): Promise<IReklamacja | undefined> 
    update(reklamacja:IReklamacja): Promise<IReklamacja | undefined> 
    delete(reklamacja:IReklamacja): Promise<IReklamacja | undefined> 
}